import styled from 'styled-components'

import { Typography } from 'primsell-shared-layer/components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const TextTypography = styled(Typography)`
  color: ${baseTheme.colors.lightDark};
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 140%;
`
